<template>
  <v-modal name="in-app-product" height="auto" :width="450" close-button scrollable
    @before-open="data = $event.params.data">
    <in-app-product-header class="header" :icon="data.icon_uri" :name="$jt(data.name_json)"
      :description="$jt(data.description_json)" />
    <ul class="info">
      <li>
        <strong>{{ $t('TYPE') }}</strong>
        <span>{{ data.type_translated }}</span>
      </li>
      <li>
        <strong>{{ $t('PRICE') }}</strong>
        <span>{{ formatCurrency(data.price_cents_eur) }}</span>
      </li>
      <li v-if="data.tos_text">
        <strong>{{ $t('TOS') }}</strong>
        <span><button class="g-pseudo-link"
            @click.prevent="$modal.show('markdown-document', data.tos_text)">View</button></span>
      </li>
    </ul>
  </v-modal>
</template>

<script>
import InAppProductHeader from '@/components/InAppProductHeader.vue';
import VModal from '@/components/VModal.vue';
import formatCurrency from '@/utils/formatCurrency';

export default {
  components: { VModal, InAppProductHeader },
  data() {
    return {
      data: {
        identifier: '',
        name_json: '',
        description_json: '',
        type: '',
        price_cents_eur: 0,
        app_identifier: '',
        amount: 0,
        icon_uri: '',
        license_type: '',
        tos_text: '',
        is_enabled: 0,
        stripe_price_id: '',
        type_translated: '',
      },
    };
  },
  methods: {
    formatCurrency,
  },
};
</script>

<style lang="scss" scoped>
.info {
  margin-top: 15px;

  li:not(:last-child) {
    margin-bottom: 5px;
  }

  strong:first-child {
    margin-right: 5px;
  }
}
</style>
